import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PaginatorAnimated from '../../core/PaginatorAnimated';
import PressRelease from '../../core/PressRelease';
import { showPressReleases } from '../../../actions/pressRelease';
import Loading from '../../core/Loading';

class PressReleaseHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: !props.pressRelease.length,
      pressRelease: props.pressRelease
    };
  }

  componentDidMount() {
    const { showPressRelease } = this.props;
    const { pressRelease } = this.state;

    if (!pressRelease.length) {
      showPressRelease().then(data => {
        this.setState({
          loading: false,
          pressRelease: data
        });
      });
    }
  }

  render() {
    const { loading, pressRelease } = this.state;
    return loading ? (
      <Loading size="xl" />
    ) : (
      <PaginatorAnimated data={pressRelease}>
        <PressRelease pressRelease={pressRelease} />
      </PaginatorAnimated>
    );
  }
}

PressReleaseHome.propTypes = {
  pressRelease: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired
};

const mapStateToProps = state => ({
  pressRelease: state.pressRelease.pressReleases
});

const mapDispatchToProps = dispatch => ({
  showPressRelease: () => showPressReleases(dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PressReleaseHome);
